var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{style:({
    'max-height': (_vm.height + "px !important"),
    'max-width': (_vm.width + "px !important"),
  }),attrs:{"id":_vm.canvasId}})}
var staticRenderFns = []

export { render, staticRenderFns }